<script setup lang="ts">
const { t, tm, rt } = useI18n()

const items = computed(() =>
  (tm('faq.items') as any[]).map((it, i) => ({
    label:       rt(it.q),
    content:     rt(it.a),
    value:       `q-${i}`,
    defaultOpen: i === 0,
  })),
)
</script>

<template>
  <section id="faq" class="rod-section relative">
    <div class="rod-container max-w-3xl">
      <div class="text-center mb-10" data-reveal>
        <div class="rod-eyebrow mb-5">❓ {{ t('faq.eyebrow') }}</div>
        <h2 class="rod-h2">{{ t('faq.title') }}</h2>
      </div>

      <UAccordion
        :items="items"
        :ui="{
          root: 'flex flex-col gap-3',
          item: 'rod-card overflow-hidden',
          header: 'py-4 flex items-center justify-between gap-4 cursor-pointer font-display font-semibold text-base sm:text-lg',
          trigger: 'w-full text-left flex items-start justify-between gap-4',
          body: 'text-[var(--color-text-muted)] pb-4 leading-relaxed',
        }"
        data-reveal
      />
    </div>
  </section>
</template>
